<template>
    <div :id="'grp_' + id" :class="groupClasses">

        <label :for="id" v-if="label != null" :class="labelClasses" ref="label">
            {{mandatory ? label + ' *' : label}}
        </label>

        <input :id="id" :name="id" :type="type" ref="input"
               :placeholder="placeholder" :autocomplete="autocomplete"
               :class="inputClasses"
               v-on:keypress.enter="onEnterPressed"
               :disabled="disabled"
               v-bind:value="value"
               spellcheck="false"
               v-on:change="$emit('change', $event.target.value)"
               v-on:input="$emit('input', $event.target.value)"
               v-on:click.right="$emit('click.right', $event)"
               v-on:copy="$emit('copy', $event)"
               v-on:paste="$emit('paste', $event)"
               :autofocus="focused" v-if="icon===null"
               :aria-required="mandatory"
               :aria-invalid="invalid"
               :aria-describedby="ariaErrorElementId"
        />

        <div class="ui right icon input" v-else>
            <input :id="id" :name="id" :type="type" ref="input"
                   :placeholder="placeholder" :autocomplete="autocomplete"
                   :class="inputClasses"
                   v-on:keypress.enter="onEnterPressed"
                   :disabled="disabled"
                   v-bind:value="value"
                   v-on:change="$emit('change', $event.target.value)"
                   v-on:input="$emit('input', $event.target.value)"
                   v-on:click.right="$emit('click.right', $event)"
                   v-on:copy="$emit('copy', $event)"
                   v-on:paste="$emit('paste', $event)"
                   :autofocus="focused"
                   :aria-required="mandatory"
                   :aria-invalid="invalid"
                   :aria-describedby="ariaErrorElementId"/>
            <i :class="icon"></i>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    id: String,
    placeholder: String,
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    groupClasses: {
      type: String,
      default: 'ui fluid input'
    },
    labelClasses: {
      type: String,
      default: 'placeholder label'
    },
    inputClasses: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    ariaErrorElementId: {
      type: String,
      default: ''
    }
  },
  methods: {
    onEnterPressed: function (e) {
      this.$emit('enter-pressed', e)
    },
    focus () {
      this.$refs.input.focus()
    }
  },
  mounted: function () {
    const label = this.$refs.label
    const isStatic = label.classList.contains('static')
    const inputElement = this.$refs.input

    inputElement.addEventListener('focusin', () => {
      label.classList.add('active')
    })
    inputElement.addEventListener('focusout', () => {
      label.classList.remove('active')
    })

    if (!isStatic) {
      inputElement.addEventListener('change', () => {
        if (this.value && this.value.length > 0) {
          label.classList.add('filled')
        } else {
          label.classList.remove('filled')
        }
      })

      if (this.value && this.value.length > 0) {
        label.classList.add('filled')
      }
    }
  },
  beforeUpdate () {
    const label = this.$refs.label
    if (this.value && this.value.length > 0) {
      label.classList.add('filled')
    }
  }
}
</script>

<style scoped>

    .ui.form .ui.fluid.input > label.placeholder.label {
        z-index: 2;
    }
</style>
